import { useContext, useEffect, useState, useCallback } from 'react'; 
import get from 'lodash/get';
import { reAdd } from './layers';
import { AppContext } from './AppContext';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp';
import { continuousPaint } from './paint';

const grainBidsLId = 'barcharts-grainbids';

const grainBidsL = (data) => ({
    id: grainBidsLId,
    type: 'circle',
    source: {
        type: 'geojson',
        data,
        // data: 'https://storage.googleapis.com/acretrader-ds.appspot.com/data/barchart.json'
    }
})

// symbol":"ZCN21"
// # 'commodity': 'Soybeans', 'symbol': 'ZSN21', 'delivery_start': '2021-05-01 00:00:00', 'delivery_end': '2021-05-31 23:59:59', 'basis': '-5.00'deliveryMonth basismonth cashprice


function onClusterPoint(e) {
  const map = e.target;

  const coordinates = [e.lngLat.lng, e.lngLat.lat];
  console.log(e.features);
  new mapboxgl.Popup()
      .setLngLat(coordinates)
      .setHTML(
        Object.entries(e.features[0].properties)
        .map(([k, v]) => {
          return `<div> <span style="font-weight:bold;"> ${k} </span>: ${v} </div>`;
        }).join('')
      )
      .addTo(map);
}


function inPointer(e) {
  const map = e.target;
  map.getCanvas().style.cursor = 'pointer';
}


function outPointer(e) {
  const map = e.target;
  map.getCanvas().style.cursor = '';
}


// TODO legend and switch
const dataProp = 'ZCN21';


function movePaint(e) {
  const map = e.target;
  if (!map.getLayer(grainBidsLId)) return;
  // TODO qquerySourceFeatures
  // TOOD just do this on backend?
  const features = map.queryRenderedFeatures({ layers: [grainBidsLId] });
  const values = features.map(f => f.properties[dataProp]);
  const propExpression = ["get", dataProp];
  if (values.length === 0) return;
  const paint = continuousPaint(propExpression, values); 
  map.setPaintProperty(grainBidsLId, 'circle-color', paint);
}


function interActions(map, toggle, layerId) {
    if (toggle) {
        map.on('moveend', layerId, movePaint);
        map.on('mouseenter', layerId, inPointer);
        map.on('mouseleave', layerId, outPointer);
        map.on('click', layerId, onClusterPoint);
    } else {
        map.off('moveend', layerId, movePaint);
        map.off('mouseenter', layerId, inPointer);
        map.off('mouseleave', layerId, outPointer);
        map.off('click', layerId, onClusterPoint);
    }
} 


export function useBarcharts () {
    const { mapboxRef } = useContext(AppContext);
    const [data, setData] = useState({'type': 'FeatureCollection', 'features': []});

    useEffect(() => {
      fetch('https://storage.googleapis.com/acretrader-ds.appspot.com/data/barchart.json')
        .then(r => r.json())
        .then(r => {
          // TODO do this backend then just use url in source
          r.features.forEach(f => {
            const bids = get(f.properties.bids, 'bids', [])
                .filter(b => b.symbol === dataProp);

            if (bids.length > 0) {
              f.properties[dataProp] = bids[0]['basis'];
            }
            f.properties.bids = get(f.properties.bids, 'bids', []).map(b => {
              return `${b.commodity} ${b.deliveryMonth}: ${b.basis} (${b.price})`
            }).join(', ')
          
          })
          setData(r);
          movePaint({target: mapboxRef.current});
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const grainBidsToggle = useCallback((toggle) => {
        interActions(mapboxRef.current, toggle, grainBidsLId);
        reAdd(mapboxRef.current, toggle, grainBidsL(data));
        movePaint({target: mapboxRef.current});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    return { grainBidsToggle };

}